import { render, staticRenderFns } from "./SortProducts.vue?vue&type=template&id=f6869da2&"
import script from "./SortProducts.vue?vue&type=script&lang=js&"
export * from "./SortProducts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports